import type { PanoramaClientForComponent } from '@wix/panorama-client';

// create a singleton instance of the interaction controller
// that is defined by a string

export class InteractionController {
  private static interactionsStack: { [key: string]: number };

  private constructor() {}

  private static getStackSize(interaction: string) {
    if (!InteractionController.interactionsStack) {
      InteractionController.interactionsStack = {};
    }
    if (!InteractionController.interactionsStack[interaction]) {
      InteractionController.interactionsStack[interaction] = 0;
    }
    return InteractionController.interactionsStack[interaction];
  }

  private static setStackSize(interaction: string, size: number) {
    if (!InteractionController.interactionsStack) {
      InteractionController.interactionsStack = {};
    }
    InteractionController.interactionsStack[interaction] = size;
  }

  static interactionStarted(interaction: string, panoramaClient?: PanoramaClientForComponent) {
    if (!panoramaClient) {
      console.error(`panoramaClient is not set, ${interaction} tried to interact`);
      return;
    }
    const stackSize = InteractionController.getStackSize(interaction);
    if (stackSize === undefined) {
      return;
    }

    panoramaClient.transaction(interaction).start();
    InteractionController.setStackSize(interaction, stackSize + 1);
  }

  static interactionEnded(interaction: string, panoramaClient?: PanoramaClientForComponent) {
    if (!panoramaClient) {
      console.error(`panoramaClient is not set, ${interaction} tried to interact`);
      return;
    }

    const stackSize = InteractionController.getStackSize(interaction);
    if (!stackSize) {
      return false;
    }

    panoramaClient.transaction(interaction).finish();
    InteractionController.setStackSize(interaction, stackSize - 1);
  }
}
